import { render, staticRenderFns } from "./access-control-modal.vue?vue&type=template&id=7978caf7&scoped=true&"
import script from "./access-control-modal.vue?vue&type=script&lang=js&"
export * from "./access-control-modal.vue?vue&type=script&lang=js&"
import style0 from "./access-control-modal.vue?vue&type=style&index=0&id=7978caf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7978caf7",
  null
  
)

export default component.exports